import React, { FC, useEffect, useState } from "react";
import { YhBox } from "@/components/YhBox";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useDiscernModel } from "../../discernModel";

export const Content: FC<RouterParamType> = ({ id, mode }) => {
	const { LabelInfoDrawer, LabelResultDrawer, setLabelInfoDrawer, discernOne, getDiscernOne } = useDiscernModel();
	const [shiftCurrent, setShiftCurrent] = useState<boolean>(true);

	useEffect(() => {
		getDiscernOne(id).then(res => {
			if (res.sourceFrom === "北京产权交易平台" || res.sourceFrom === "天津产权交易平台" || res.sourceFrom === "北交互联" || res.sourceFrom === "公共资源" || res.sourceFrom === "云筑网") {
				setShiftCurrent(false)
				window.open(res.detailLink, `${res.title}`, "width=400,height=400,screenX=200,screenY=200")
			}
		})
	}, []);

	const renderContent = () => {
		if (discernOne?.rawContent) {
			return discernOne?.rawContent ?? "<span>暂无内容,请通过原文链接进行访问。</span>";
		} else {
			return `<span>${discernOne?.textContent ?? '暂无内容,请通过原文链接进行访问。'}</span>`;
		}
	}


	return (
		<YhBox
			title=" "
			style={{ padding: 0, marginBottom: "15px" }}
		>
			<div className="iframe-container" style={{ width: `calc(100% - ${LabelInfoDrawer ? "776px" : LabelResultDrawer.visible ? "490px" : "0px"})` }}>
				<span
					style={{ display: "inline-block", width: "80px", height: "20px", border: "1px solid #aaa", fontSize: "12px", lineHeight: "20px", textAlign: "center", cursor: "pointer" }}
					onClick={() => setShiftCurrent(origin => !origin)}
				>{shiftCurrent ? "转换原文内容" : "转换Iframe"}</span>
				{
					shiftCurrent && discernOne?.detailLink && discernOne.detailLink.indexOf("http") > -1 ? <>
						<iframe
							id="ifr"
							src={discernOne?.sourceFrom === "中国交建" ? `./iframePost.html?actionBms=${discernOne?.detailLink}&oid=${discernOne?.oid}` :
								// discernOne?.sourceFrom === "中国石油招标投标网" ? `./iframePetrochina.html?actionBms=actionBms=https://www.cnpcbidding.com&oid=${discernOne?.oid}` :
								discernOne?.sourceFrom === "中国石油招标投标网" ? "https://www.cnpcbidding.com" :
									discernOne?.sourceFrom === "中国电建" ? `./iframePost.html?actionBms=${discernOne?.pdfviewLink ?? discernOne?.detailLink}&oid=${discernOne?.oid}` :
										discernOne?.sourceFrom === "中铁鲁班商务网" ? `./iframe.html?actionBms=${discernOne?.pdfviewLink ?? discernOne?.detailLink}` :
											discernOne?.sourceFrom === "中国石化物资招标投标网" ? `./iframeSinopec.html?actionBms=${discernOne?.detailLink}` :
												discernOne?.sourceFrom === "中国招标投标公共服务平台" ? `./iframeSinopec.html?actionBms=${discernOne?.pdfviewLink ?? discernOne?.detailLink}` :
													`./iframe.html?actionBms=${discernOne?.detailLink}`
							}
							// src={`${discernOne?.detailLink}`}
							scrolling="yes"
							frameBorder="0"
							style={{ width: '100%', height: "100%", overflow: 'visible' }}
						></iframe></>
						// : <div className="ml-20" style={{ height: "100%", overflow: "auto" }} >{discernOne?.rawContent ?? "暂无内容"}</div>
						: <div className="ml-20" style={{ height: "100%", padding: "0 0 20px", overflow: "auto" }} dangerouslySetInnerHTML={{ __html: renderContent() }}></div>
				}
			</div>
		</YhBox>
	)
}